import { UserPromotions } from './UserPromotionsDialog'

export const ProfilePromotions = () => {
  return <UserPromotions />
}
